<template>
    <div id="vehicle_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name" v-if="request_flag != 'load'">
                    <span class="page-title" id="vehicleHeader">Transport Request Form</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackRequestList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content transport-form">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal form-custom-select basic-form-container" id="TransportingRequestForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="requested_by">Requested By:</label>
                                        <input type="text" class="form-control" v-model="requested_by" id="requested_by" placeholder="Enter Requested By" name="requested_by">
                                        <div class="field-error">{{requested_by_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="requested_date">Requested Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="requested_date" name="requested_date" v-model="requested_date" :config="options"></date-picker>
                                            <label for="requested_date"  class="fp-calendar input-calender-icon"></label>
                                        </div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="unit_no">Unit No:</label>
                                        <input type="text" class="form-control" v-model="unit_no" id="unit_no" placeholder="Enter Unit No" name="unit_no">
                                        <div class="field-error">{{unit_no_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="customer_name">Customer:</label>
                                        <input type="text" class="form-control" v-model="customer_name" id="customer_name" placeholder="Enter Customer Name" name="customer_name">
                                        <div class="field-error">{{customer_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="pickup_location">Pickup Location:</label>
                                        <v-select v-model="pickup_location" name="pickup_location" placeholder="Select Pickup Location."
                                                label="text"
                                                :options="pickUpLocArr">
                                        </v-select>
                                        <div class="field-error">{{pickup_location_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="pick_address">Address (If Customer):</label>
                                        <input type="text" class="form-control" v-model="pick_address" id="pick_address" placeholder="Enter Customer Address" name="pick_address">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="delivery_location">Delivery Location:</label>
                                        <v-select v-model="delivery_location" name="delivery_location" placeholder="Select Delivery Location."
                                                label="text"
                                                :options="deliveryLocArr">
                                        </v-select>
                                        <div class="field-error">{{delivery_location_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="delivery_address">Address (If Customer):</label>
                                        <input type="text" class="form-control" v-model="delivery_address" id="delivery_address" placeholder="Enter Customer Address" name="delivery_address">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="billing">Who are we billing?:</label>
                                        <v-select v-model="billing" name="billing" placeholder="Select"
                                                label="text"
                                                :options="billingArr">
                                        </v-select>
                                        <div class="field-error">{{billing_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vin">RS# or WO#:</label>
                                        <input type="text" class="form-control" v-model="rs_wo" id="rs_wo" placeholder="Enter #RS or WO#" name="rs_wo">
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="transporting">Who is transporting?:</label>
                                        <v-select v-model="transporting" name="transporting" placeholder="Select"
                                                label="text"
                                                :options="transportingArr">
                                        </v-select>
                                        <div class="field-error">{{transporting_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="get_back">How will they get back?:</label>
                                        <v-select v-model="get_back" name="get_back" placeholder="Select"
                                                label="text"
                                                :options="getBackArr">
                                        </v-select>
                                        <div class="field-error">{{get_back_err_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="vin">Approval#:</label>
                                        <input type="text" class="form-control" v-model="approval_no" id="approval_no" placeholder="Enter Approval No" name="approval_no">
                                        <div class="field-error">{{approval_no_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="comments">Comments:</label>
                                        <input type="text" class="form-control" v-model="comments" id="comments" placeholder="Enter Comments" name="comments">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createTransportBtn" class="btn btn-primary" v-on:click.prevent="StoreTransportData" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueTransportBtn" class="btn btn-tertiary" v-on:click.prevent="StoreTransportData(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button v-if="request_flag != 'load'" type="submit" id="cancelTransportBtn" class="btn btn-tertiary" v-on:click.prevent="BackRequestList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer v-if="request_flag != 'load'"></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../../mixins/commonMixins';


export default {
  name: "TransportRequestForm",
  
  metaInfo() {
      return {
          title: "Transport Request Create | " +process.env.COPYRIGHT_NAME
      }
  },
  mixins:[commonMixins],
  data: () => ({
    isEdit:false,
    permissions: [],
    cantAccessPage: true,
    
    sitekey:"6Lf4Io4UAAAAAByVmOV4fn2P5RAqBEq8D8fBbqNb",
    requested_by: "",
    requested_date: "",
    customer_name: "",
    unit_no: "",
    pickup_location: null,
    pick_address: "",
    delivery_location: null,
    delivery_address: "",
    billing: null,
    rs_wo: "",
    transporting: null,
    get_back: null,
    approval_no: "",
    comments: "",
    pickUpLocArr: [
        {
            value: "CITY OF INDUSTRY",
            text: "CITY OF INDUSTRY"
        },
        {
            value: "Rancho Dominguez",
            text: "Rancho Dominguez"
        },
        {
            value: "FONTANA",
            text: "FONTANA"
        },
        {
            value: "SAN DIEGO",
            text: "SAN DIEGO"
        },
        {
            value: "TOLLESON",
            text: "TOLLESON"
        },
        {
            value: "CHANDLER",
            text: "CHANDLER"
        },
        {
            value: "TUCSON",
            text: "TUCSON"
        },
        {
            value: "Customer",
            text: "Customer"
        }
    ],
    deliveryLocArr: [
        {
            value: "CITY OF INDUSTRY",
            text: "CITY OF INDUSTRY"
        },
        {
            value: "Rancho Dominguez",
            text: "Rancho Dominguez"
        },
        {
            value: "FONTANA",
            text: "FONTANA"
        },
        {
            value: "SAN DIEGO",
            text: "SAN DIEGO"
        },
        {
            value: "TOLLESON",
            text: "TOLLESON"
        },
        {
            value: "CHANDLER",
            text: "CHANDLER"
        },
        {
            value: "TUCSON",
            text: "TUCSON"
        },
        {
            value: "Customer",
            text: "Customer"
        }
    ],

    billingArr: [
        {
            value: "skip",
            text: "Skip"
        },
        {
            value: "customer",
            text: "Customer"
        }
    ],
    transportingArr: [
        {
            value: "internal",
            text: "Internal"
        },
        {
            value: "external",
            text: "External"
        }
    ],
    getBackArr: [
        {
            value: "lyft",
            text: "Lyft"
        },
        {
            value: "truck_back",
            text: "Truck back"
        }
    ],
    options: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    loading:false,

    billing_err_msg: "",
    approval_no_error_msg: "",
    get_back_err_msg: "",
    transporting_err_msg: "",
    delivery_location_err_msg: "",
    pickup_location_err_msg: "",
    unit_no_error_msg: "",
    customer_err_msg: "",
    requested_by_err_msg: "",
    captchaerror: "",
    googleResponse: "",
    request_flag: '',
    
  }),
  watch: {

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'transport_request') {
                        self.cantAccessPage = true;
                    }
                }
            }
      },
  },
  created: function() {

  },
  mounted: function() {

        var self = this;

        var path = window.location.pathname;
        var flag = path.split("/");
        self.request_flag = flag[2];
        
        if(self.request_flag != 'load') {
            self.getPermissions();
        }
  },
  methods: {
      
    BackRequestList() {
      var self = this;
      self.$router.push('/transportrequest/list');
    },

    StoreTransportData(flag) {
        var self = this;
        var error = false;

        self.billing_err_msg = "";
        self.approval_no_error_msg = "";
        self.get_back_err_msg = "";
        self.transporting_err_msg = "";
        self.delivery_location_err_msg = "";
        self.pickup_location_err_msg = "";
        self.unit_no_error_msg = "";
        self.customer_err_msg = "";
        self.requested_by_err_msg = "";

        if (!self.requested_by || self.requested_by == null || self.requested_by == "") {
            self.requested_by_err_msg = "Requested Name Required.";
            error = true;
        }

        if (!self.customer_name || self.customer_name == null || self.customer_name == "") {
            self.customer_err_msg = "Customer Name Required.";
            error = true;
        }

        if (!self.unit_no || self.unit_no == null || self.unit_no == "") {
            self.unit_no_error_msg = "Unit No Required.";
            error = true;
        }

        if (!self.approval_no || self.approval_no == null || self.approval_no == "") {
            self.approval_no_error_msg = "Approval No Required.";
            error = true;
        }

        if (self.pickup_location == null || !self.pickup_location.value) {
            self.pickup_location_err_msg = "Pick Location Required.";
            error = true;
        }

        if (self.transporting == null || !self.transporting.value ) {
            self.transporting_err_msg = "Transporting Required.";
            error = true;
        }

        if (self.delivery_location == null || !self.delivery_location.value) {
            self.delivery_location_err_msg = "Delivery Location Required.";
            error = true;
        } 

        if (self.get_back == null || !self.get_back.value) {
            self.get_back_err_msg = "Get Back Required.";
            error = true;
        } 

        if (!error) {
            self.loading = true;
            
            if (flag == "Save and Continue") {

                $("#createAndContinueTransportBtn").val("Saving ...");
                $("#createTransportBtn").prop("disabled", true);
                $("#createAndContinueTransportBtn").prop("disabled", true);
                $("#cancelTransportBtn").prop("disabled",true);

            }else{

                $("#createTransportBtn").val("Saving ...");
                $("#createTransportBtn").prop("disabled", true);
                $("#createAndContinueTransportBtn").prop("disabled", true);
                $("#cancelTransportBtn").prop("disabled",true);
            }

            var fields = $("#TransportingRequestForm").serializeArray();
            fields.push({name: "pickup_location", value: self.pickup_location.value});
            fields.push({name: "delivery_location", value: self.delivery_location.value});
            fields.push({ name: "billing", value: self.billing.value });
            fields.push({name: "transporting", value: self.transporting.value});
            fields.push({name: "get_back", value: self.get_back.value});
            
            $.ajax({
                url: process.env.ROOT_API + "/transport-request/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    
                    if (flag == "Save and Continue") {

                        $("#createAndContinueTransportBtn").val("Save and Continue");
                        $("#createTransportBtn").prop("disabled", false);
                        $("#createAndContinueTransportBtn").prop("disabled", false);
                        $("#cancelTransportBtn").prop("disabled",false);

                    }else{

                        $("#createTransportBtn").val("Save");
                        $("#createTransportBtn").prop("disabled", false);
                        $("#createAndContinueTransportBtn").prop("disabled", false);
                        $("#cancelTransportBtn").prop("disabled",false);

                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#TransportingRequestForm").trigger("reset");
                            self.requested_by = "";
                            self.requested_date = "";
                            self.customer_name = "";
                            self.unit_no = "";
                            self.pickup_location = null;
                            self.pick_address = "";
                            self.delivery_location = null;
                            self.delivery_address = "";
                            self.billing = null;
                            self.rs_wo = "";
                            self.transporting = null;
                            self.get_back = null;
                            self.approval_no = "";
                            self.comments = "";

                        } else {
                            if(self.request_flag != 'load') {
                                self.$router.push('/transportrequest/list');
                            } else {
                            
                                $("#TransportingRequestForm").trigger("reset");
                                self.requested_by = "";
                                self.requested_date = "";
                                self.customer_name = "";
                                self.unit_no = "";
                                self.pickup_location = "";
                                self.pick_address = "";
                                self.delivery_location = "";
                                self.delivery_address = "";
                                self.billing = "";
                                self.rs_wo = "";
                                self.transporting = "";
                                self.get_back = "";
                                self.approval_no = "";
                                self.comments = "";
                            }

                            // sweetAlert(data.content.message,'','success');
                            // this.$swal("Success!", "Your Transpost Request Form added successful.", "success");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {

                    self.loading = false;
                    
                    if (flag == "Save and Continue") {

                        $("#TransportingRequestForm").trigger("reset");
                        

                        $("#createAndContinueTransportBtn").val("Save and Continue");
                        $("#createTransportBtn").prop("disabled", false);
                        $("#createAndContinueTransportBtn").prop("disabled", false);
                        $("#cancelTransportBtn").prop("disabled",false);

                    }else{

                        $("#createTransportBtn").val("Save");
                        $("#createTransportBtn").prop("disabled", false);
                        $("#createAndContinueTransportBtn").prop("disabled", false);
                        $("#cancelTransportBtn").prop("disabled",false);

                    }
                    self.generateStatusCodeMessage(jqXHR, false, 'transport-req-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }
    },

    formatString(data) {
        var self = this;
        var value = data.replace(/_/g, " ");
        var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
            return letter.toUpperCase();
        });
        return upp;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/TransportRequestForm/TransportRequestForm.vue